import { CalendarClock } from "lucide-react";
import { Link, useParams } from "react-router";
import { Button } from "@/components/ui/button.tsx";

export function NoBaseline() {
	const { obra: obraKey } = useParams();

	return (
		<div className="dashboard-no-baseline">
			<CalendarClock className="dashboard-no-baseline__icon" />
			<p className="dashboard-no-baseline__title">
				Esta obra ainda não tem cronograma
			</p>
			<p className="dashboard-no-baseline__description">
				Planeje as datas das etapas para acompanhar o previsto contra o
				realizado.
			</p>
			<Button asChild>
				<Link to={`/${obraKey}/cronograma`}>Abrir cronograma</Link>
			</Button>
		</div>
	);
}
